export const VACANCIES_LIST_PATH = "/vacancies/";
